<app-price-robot-submenu *ngIf="!embedded"></app-price-robot-submenu>
<div class=" pb-1" [ngClass]="{
container: !embedded,
faded: loading}" *ngIf="rules != null; else spinner">
    <button class="btn btn-primary mt-4" [routerLink]="'/price-robot/rule/0'" *ngIf="!embedded">Tilføj ny regel</button>

    <p class="h4 mt-4" *ngIf="embedded">
        Rules
    </p>

    <p class="h4 mt-4" *ngIf="!embedded">
        Aktive
    </p>
    <table class="table table-striped align-middle mt-4 table-sm">
        <tr>
            <th style="width: 25px;"></th>
            <th>Navn</th>
            <th>Kriterier</th>
            <th>Handlinger</th>
            <th>Aktiv</th>
            <th>Aktiv Start</th>
            <th>Aktiv Slut</th>
        </tr>
        <tbody [sortablejs]="rules" [sortablejsOptions]="sortableOptions">
        <tr *ngFor="let rule of rules">
            <td><span style="cursor: move;" *ngIf="!embedded">=</span></td>
            <td>
                <ng-container *ngIf="rule.name !== null && rule.name !== ''; else none">
                    <a [routerLink]="'/price-robot/rule/' + rule.id">{{rule.name}}</a>
                </ng-container>
                <ng-template #none>
                    <a [routerLink]="'/price-robot/rule/' + rule.id">Intet navn</a>
                </ng-template>
            </td>
            <td>{{ rule.rules_conditions.length }}</td>
            <td>{{ rule.rules_actions.length }}</td>
            <td>
                <ng-container *ngIf="rule.is_active">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green"
                         class="bi bi-check2-square" viewBox="0 0 16 16">
                        <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/>
                        <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                    </svg>
                </ng-container>
                <ng-container *ngIf="!rule.is_active">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-x-square"
                         viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </ng-container>
            </td>
            <td>
                <ng-container *ngIf="rule.active_start !== null">
                    {{rule.active_start.toString().split('T')[0]}}
                </ng-container>
            </td>
            <td>
                <ng-container *ngIf="rule.active_end !== null">
                    {{rule.active_end.split('T')[0]}}
                </ng-container>
            </td>
        </tr>
        </tbody>
    </table>

    <p class="h2 mt-4" *ngIf="!embedded">
        Ikke aktive
    </p>
    <table class="table table-striped align-middle mt-4 table-sm"*ngIf="!embedded">
        <tr>
            <th></th>
            <th>Navn</th>
            <th>Kriterier</th>
            <th>Handlinger</th>
            <th>Aktiv</th>
            <th>Aktiv Start</th>
            <th>Aktiv Slut</th>
        </tr>
        <tbody>
        <tr *ngFor="let rule of inactiveRules">
            <td>
                <ng-container *ngIf="rule.name !== null && rule.name !== ''; else none">
                    <a [routerLink]="'/price-robot/rule/' + rule.id">{{rule.name}}</a>
                </ng-container>
                <ng-template #none>
                    <a [routerLink]="'/price-robot/rule/' + rule.id">Intet navn</a>
                </ng-template>
            </td>
            <td>{{ rule.rules_conditions.length }}</td>
            <td>{{ rule.rules_actions.length }}</td>
            <td>
                <ng-container *ngIf="rule.is_active">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green"
                         class="bi bi-check2-square" viewBox="0 0 16 16">
                        <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/>
                        <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                    </svg>
                </ng-container>
                <ng-container *ngIf="!rule.is_active">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-x-square"
                         viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </ng-container>
            </td>
            <td>
                <ng-container *ngIf="rule.active_start !== null">
                    {{rule.active_start.toString().split('T')[0]}}
                </ng-container>
            </td>
            <td>
                <ng-container *ngIf="rule.active_end !== null">
                    {{rule.active_end.split('T')[0]}}
                </ng-container>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
